import { render, staticRenderFns } from "./StoreItemList.vue?vue&type=template&id=2f716035&"
import script from "./StoreItemList.vue?vue&type=script&lang=js&"
export * from "./StoreItemList.vue?vue&type=script&lang=js&"
import style0 from "./StoreItemList.vue?vue&type=style&index=0&id=2f716035&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports